import React from 'react';
import { IAnswerMapping } from '../QuestionnairePrintView.service';
import styles from '../QuestionnairePrintView.module.scss';

const CountryStateTemplate: React.FC<{
  answerMapping: Record<string, IAnswerMapping>;
}> = ({ answerMapping }) => {
  const countryAnswer = answerMapping['0']?.answerForQuestion;
  const stateAnswer = answerMapping['1']?.answerForQuestion;

  return (
    <div className={styles['group-type-answer']}>
      <div className={styles['sub-type-answer']}>
        <label>Country/Location</label>
        <p>{countryAnswer}</p>
      </div>
      <div className={styles['sub-type-answer']}>
        <label>State/Province/Region</label>
        <p>{stateAnswer}</p>
      </div>
    </div>
  );
};

export default CountryStateTemplate;
